import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'CheckoutForm',
    component: () => import('../views/CheckoutUnAuth.vue'),
  },
  {
    path: '/afterSummary',
    name: 'AfterSummary',
    component: () => import('../views/AfterSummary.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    // Всегда скроллим наверх при переходе
    return { top: 0, behavior: 'smooth' }
  },
})

export default router
